import type { JobExecutionStatus, JobStatus } from '@stratumn/jobs';
import { observer } from 'mobx-react';

import { getIconColors, getIconStatus, statusIconMap } from '../utils';

type ETLStatusIconProps = {
  jobStatus: JobStatus;
  jobExecutionStatus?: JobExecutionStatus;
};

const ETLStatusIcon = ({
  jobExecutionStatus,
  jobStatus
}: ETLStatusIconProps) => {
  const iconStatus = getIconStatus(jobStatus, jobExecutionStatus);
  const { bgColor, color } = getIconColors(iconStatus);
  if (!(bgColor && color)) {
    return;
  }
  const IconComponent = statusIconMap[iconStatus];
  return (
    <div className="flex items-center gap-2">
      <div
        className={`flex items-center justify-center rounded-full p-2 ${bgColor} border`}
      >
        {IconComponent ? <IconComponent className={color} size={18} /> : null}
      </div>
    </div>
  );
};

export default observer(ETLStatusIcon);
